<template>
  <div
    class="border-gray flex flex-col gap-3 rounded-lg border bg-white shadow-md"
    :class="className"
  >
    <vue-collapsible-panel-group
      accordion
      class="load-collapsible rounded-lg"
    >
      <vue-collapsible-panel>
        <template #title>
          <div
            class="flex items-center justify-between rounded-lg bg-white py-2 pl-3 pr-1 text-xs font-semibold text-dark-gray"
          >
            <p class="text-xl font-medium">{{ title }}</p>
            <LoadBadge
              v-if="badgeText"
              :text="badgeText"
              :color="badgeColor"
            />
          </div>
        </template>
        <template #content>
          <slot />
        </template>
      </vue-collapsible-panel>
    </vue-collapsible-panel-group>
  </div>
</template>

<script>
import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from '@dafcoe/vue-collapsible-panel';
import LoadBadge from '@/components/loads/LoadBadge.vue';

export default {
  name: 'CollapsibleLoadDetails',
  components: {
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel,
    LoadBadge,
  },
  props: {
    title: String,
    load: Object,
    badgeText: String,
    className: Object,
    badgeColor: {
      type: String,
      required: false,
      default: 'gray',
    },
  },
};
</script>

<style>
.load-collapsible .vcp__header-title,
.load-collapsible .vcp.vcp--expanded .vcp__header,
.load-collapsible .vcp__header,
.load-collapsible .vcp__header:hover,
.load-collapsible .vcp__header-icon {
  background: white !important;
  @apply rounded-lg;
}
</style>
